"use client";

import { createContext, useContext } from "react";

export interface DialogContextValue {
  titleId: string;
  descriptionId: string;
  close: () => void;
}

export const DialogContext = createContext<DialogContextValue | null>(null);

export const useDialog = (): DialogContextValue => {
  const ctx = useContext(DialogContext);
  if (!ctx) throw new Error("Dialog parts must be used within <Dialog>.");
  return ctx;
};
